var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "jade-dropdown-selection" },
    [
      _c(
        "JadeDropdown",
        {
          attrs: { open: _vm.isOpen, allowedPlacements: _vm.allowedPlacements },
          on: { toggleOpen: _vm.toggleOpen, closePopover: _vm.closePopover },
          scopedSlots: _vm._u(
            [
              {
                key: "trigger",
                fn: function () {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "jade-dropdown-selection__trigger",
                        attrs: { "data-testid": "dropdown-selection-trigger" },
                      },
                      [_vm._t("trigger")],
                      2
                    ),
                  ]
                },
                proxy: true,
              },
            ],
            null,
            true
          ),
        },
        [
          [
            _c(
              "div",
              {
                staticClass:
                  "jade-dropdown-selection__header flex justify-between p-4",
              },
              [
                _c(
                  "jade-text",
                  {
                    attrs: {
                      color: "high",
                      weight: "bold",
                      variant: "text-large",
                    },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.title || "Selecione uma opção") + " "
                    ),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "jade-dropdown-selection__close",
                    on: { click: _vm.onCancel },
                  },
                  [
                    _c(
                      "jade-text",
                      {
                        attrs: {
                          color: "current-color",
                          weight: "medium",
                          variant: "text-medium",
                        },
                      },
                      [_vm._v(" Cancelar ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("JadeDivider"),
            _c(
              "div",
              {
                staticClass: "jade-dropdown-selection__search-wrapper",
                attrs: { "data-testid": "dropdown-selection-search" },
              },
              [
                _vm.searchable
                  ? _c("JadeInputField", {
                      attrs: {
                        value: _vm.searchValue,
                        placeholder: "Busque por uma opção",
                        leadingItem: { type: "icon", content: "action-search" },
                        label: "",
                      },
                      on: {
                        "update:value": function ($event) {
                          _vm.searchValue = $event
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "jade-dropdown-selection__content",
                attrs: { "data-testid": "dropdown-selection-content" },
              },
              [
                _c("JadeListItemSelection", {
                  attrs: {
                    options: _vm.filteredOptions || _vm.internalOptions,
                    type: _vm.type,
                  },
                  on: { onOptionChange: _vm.onOptionChange },
                }),
              ],
              1
            ),
            _c("JadeDivider"),
            _c(
              "div",
              { staticClass: "jade-dropdown-selection__trailing" },
              [_vm._t("trailing")],
              2
            ),
            _c("JadeDivider"),
            _c(
              "div",
              { staticClass: "jade-selection__footer p-4" },
              [
                _c("JadeButtonGroup", {
                  attrs: { direction: "horizontal", expanded: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ size }) {
                        return [
                          _c(
                            "JadeButton",
                            {
                              attrs: { variant: "primary-solid", size: size },
                              on: { click: _vm.onApply },
                            },
                            [_vm._v(" Aplicar ")]
                          ),
                          _c(
                            "JadeButton",
                            {
                              attrs: { size: size },
                              on: { click: _vm.onClear },
                            },
                            [_vm._v(" Limpar ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }